import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Select from '@zg-rentals/multibrand-ui/lib/Select';
import Label from '@zg-rentals/multibrand-ui/lib/Label';
import type { EndTermOptions } from '@common/types';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import DebouncedButton from '@common/components/DebouncedButton';

type Props = {
  tenantFirstName: string;
  endTermOptions: EndTermOptions;
  onSubmit: (...args: any) => void;
};

type State = {
  finalPaymentDue: string;
  lastDayOfTerm: string;
};

class CurrentTenantEndDate extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      finalPaymentDue: this.props.endTermOptions.finalDueDate1,
      lastDayOfTerm: this.props.endTermOptions.lastDayOfTerm1,
    };
  }

  onChangeSelectedDate = (e): void => {
    const index = e.currentTarget.selectedIndex;

    this.setState({
      finalPaymentDue:
        index === 0
          ? formatDate(this.props.endTermOptions.finalDueDate1, 'yyyy-MM-dd')
          : formatDate(this.props.endTermOptions.finalDueDate2, 'yyyy-MM-dd'),
      lastDayOfTerm: index === 0 ? this.props.endTermOptions.lastDayOfTerm1 : this.props.endTermOptions.lastDayOfTerm2,
    });
  };

  getSelectOptions = (): React.ReactNode => {
    const { finalDueDate1, finalDueDate2, lastDayOfTerm1, lastDayOfTerm2 } = this.props.endTermOptions;
    return (
      <>
        <option value={formatDate(finalDueDate1, 'yyyy-MM-dd')}>{formatDate(lastDayOfTerm1, 'MMMM dd, yyyy')}</option>
        <option value={formatDate(finalDueDate2, 'yyyy-MM-dd')}>{formatDate(lastDayOfTerm2, 'MMMM dd, yyyy')}</option>
      </>
    );
  };

  onSubmit = () => {
    const { onSubmit } = this.props;
    const { finalPaymentDue, lastDayOfTerm } = this.state;

    return Promise.resolve().then(() => onSubmit({ finalPaymentDue, lastDayOfTerm }));
  };

  render(): React.ReactNode {
    const { tenantFirstName } = this.props;
    const { finalPaymentDue } = this.state;
    let tenantFirstNamePossessive;
    try {
      const tenantFirstNameAsArray = tenantFirstName.split('');
      const tenantFirstNameLastLetter = tenantFirstNameAsArray[tenantFirstNameAsArray.length - 1];
      tenantFirstNamePossessive = `${tenantFirstName}'${tenantFirstNameLastLetter === 's' ? '' : 's'}`;
    } catch {
      tenantFirstNamePossessive = "Your current tenant's";
    }

    return (
      <>
        <Row>
          <Col>
            <Text type="h3">Does your end date for {tenantFirstName} look ok?</Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Label data-auto-test-id="payment-end-date-label">End date for current term</Label>
            <Select data-id="selectedDate" value={finalPaymentDue} onChange={this.onChangeSelectedDate}>
              {this.getSelectOptions()}
            </Select>
            <SpacerRow>
              <Text type="body-small">
                Your next term cannot start before this date.&nbsp;
                {tenantFirstNamePossessive} final payment is due&nbsp;
                {formatDate(finalPaymentDue, 'MMMM dd, yyyy')}.
              </Text>
            </SpacerRow>
          </Col>
        </Row>
        <Row>
          <Col>
            <DebouncedButton type="primary" full onClick={this.onSubmit}>
              Continue
            </DebouncedButton>
          </Col>
        </Row>
      </>
    );
  }
}

export default CurrentTenantEndDate;
